import React from 'react';

import { FormComponent } from 'components';
import { SearchContentsFilterType } from 'types';

interface Props {
  filter: SearchContentsFilterType;
  handleFilter: (filter: SearchContentsFilterType) => void;
}

function Filter({ filter, handleFilter }: Props) {
  return (
    <FormComponent.Form
      submit={(d: SearchContentsFilterType) =>
        handleFilter({ ...filter, ...d })
      }
    >
      <FormComponent.SearchInput
        name="title"
        placeholder="콘텐츠명으로 검색해주세요"
      />
    </FormComponent.Form>
  );
}

export default Filter;
